import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import { Container, Row, Col } from "react-bootstrap";
import BroadcastTemplateListings from "../../components/broadcast-system/broadcast-template/BroadcastTemplateListings";
import CommonStructured from "../../components/common-components/CommonStructured";
import BroadcastTemplateForm from "../../components/broadcast-system/broadcast-template/BroadcastTemplateForm";
import HelmetWrapper from "../../HelmetWrapper";
import { selectUser } from "../../components/auth/auth.selector";
import ModalHeadAndClose from "../../components/payouts-wtf/common/ModalHeadAndClose";
import { fetchBroadcastLogsData } from "../../redux/ad-blog-reducers/blogSlice";
import CmnFilters from "../../components/lead-management/common/CmnFilters";
import ModHeaderWithToggle from "../../components/common-components/custom-comps/ModHeaderWithToggle";
import BroadcastForm from "../../components/broadcast-system/broadcast-template/BroadcastForm";

const BroadcastTemplate = () => {
  const dispatch = useDispatch();
  const userInfoData = useSelector(selectUser);

  const { broadcastLogsLoading } = useSelector((state) => state.blog);

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);

  const iniAllFilter = {
    // selectedEmailTemplate: "",
    // selectedWPTemplate: "",
    selectedBroadcastChannel: "",
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    channel: allFilters.selectedBroadcastChannel?.value || "",
    // type: allFilters.selectedVariableType?.value || "",
    // value: allFilters.selectedVariableValue?.value || "",
    // status: allFilters.isActive?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);

  const iniModValues = {
    isModOpen: false,
    modName: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModValues);

  const [isToggleOn, setIsToggleOn] = useState(false);

  const onClickSearch = () => {
    setIsPage(0);
    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
    setFilters(iniFilters);
  };

  const onCloseModal = () => {
    setModValues(iniModValues);
  };

  // const getBroadcastLogs = (filters) => {
  //   dispatch(
  //     fetchBroadcastListingsData({
  //       filters: filters,
  //       token: userInfoData?.token,
  //     })
  //   );
  // };

  const getBroadcastLogs = (filters) => {
    dispatch(
      fetchBroadcastLogsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  };

  useEffect(() => {
    getBroadcastLogs(filters);
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
      channel: allFilters.selectedBroadcastChannel?.value || "",
      // type: allFilters.selectedVariableType?.value || "",
      // value: allFilters.selectedVariableValue?.value || "",
      // status: allFilters.isActive?.value || "",
    }));
  }, [
    isPage,
    pageLimit,
    allFilters.selectedBroadcastChannel,
    // allFilters.selectedVariableType,
    // allFilters.selectedVariableValue,
    // allFilters.isActive,
  ]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  return (
    <HelmetWrapper title="WTF: Broadcasts">
      <Container className="bg-cloud-k px-50px gobal-container" fluid>
        <Modal
          isOpen={modValues.isModOpen}
          onRequestClose={onCloseModal}
          contentLabel="Detail Modal"
          ariaHideApp={false}
        >
          <div
            className={`createNewCTOModalContainer ${
              modValues.modName === "add" ? "mod-height-95vh" : "mod-width-50p"
            }`}
          >
            {modValues.modName === "add" ? (
              <ModHeaderWithToggle
                title={
                  modValues.modName === "add"
                    ? "New Broadcast"
                    : modValues.modName?.replace(/_/g, " ")
                }
                onClose={() => onCloseModal()}
                isToggleOn={isToggleOn}
                onToggleChange={() => setIsToggleOn(!isToggleOn)}
              />
            ) : (
              <ModalHeadAndClose
                title={modValues.modName?.replace(/_/g, " ")}
                onClose={onCloseModal}
              />
            )}

            {modValues.modName === "description" ? (
              <div className="discussionModalMessage mt30">
                <p
                  className="message"
                  dangerouslySetInnerHTML={{
                    __html: modValues.rowData?.body || "No Content Available",
                  }}
                ></p>
              </div>
            ) : modValues.modName === "add" ? (
              <>
                {isToggleOn ? (
                  <BroadcastTemplateForm
                    closeModal={onCloseModal}
                    userInfoData={userInfoData}
                    callFunction={() => getBroadcastLogs(filters)}
                  />
                ) : (
                  <BroadcastForm
                    closeModal={onCloseModal}
                    userInfoData={userInfoData}
                    callFunction={() => getBroadcastLogs(filters)}
                  />
                )}
              </>
            ) : null}
          </div>
        </Modal>

        <Row>
          <Col>
            <CommonStructured
              pageHeading={"Broadcasts"}
              isReload={() => getBroadcastLogs(filters)}
              createBtnTxt={"+ New Broadcast"}
              onClickCreateBtn={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  modName: "add",
                }))
              }
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <CmnFilters
              from="broadcasts"
              userInfoData={userInfoData}
              searchFilterApplied={searchFilterApplied}
              filters={allFilters}
              setFilters={setAllFilters}
              onClickSearch={onClickSearch}
              onClickReset={onResetFilters}
              isLoading={broadcastLogsLoading}
              searchPlaceHolder="Search by broadcast name"
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <BroadcastTemplateListings
              isPage={isPage}
              setIsPage={setIsPage}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
              setModValues={setModValues}
              userInfoData={userInfoData}
              callFunction={() => getBroadcastLogs(filters)}
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default BroadcastTemplate;
